import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=4a1cbeb0&"
import script from "./SettingsDialog.vue?vue&type=script&lang=js&"
export * from "./SettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports